module.exports = __webpack_public_path__ + "static/media/16_tn.99321981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/16_tn.jpg
// module id = 154
// module chunks = 0